export class WorkspaceTrackingActions {
  // List
  static NAVIGATE_TO_WORKSPACE = '[Workspace] navigate to workspace detail';
  static CREATE_WORKSPACE_CLICK = '[Workspace] create workspace click';
  static CREATE_WORKSPACE_SUCCESS = '[Workspace] create workspace success';
  static DELETE_WORKSPACE_CLICK = '[Workspace] delete workspace click';
  static DELETE_WORKSPACE_SUCCESS = '[Workspace] delete workspace success';

  // Detail
  static EDIT_WORKSPACE_NAME_CLICK = '[Workspace] edit workspace name click';
  static EDIT_WORKSPACE_NAME_SUCCESS = '[Workspace] edit workspace name success';

  // Members tab
  static INVITE_USERS_CLICK = '[Workspace] invite users click';
  static INVITE_USERS_SUCCESS = '[Workspace] invite users success';
  static REMOVE_MEMBER_SUCCESS = '[Workspace] remove member success';
  static CHANGE_MEMBER_ROLE_SUCCESS = '[Workspace] change member role success';
}
